import client from '@/api/client'
import { type TimeOptionLabel } from '@/utils/time'

export const fetchFocusArea = async () => {
    return client.get('/frontline-staff/focus-area')
}

export const setActionAcknowledged = async (actionId: string) => {
    return client.post(
        `/frontline-staff/focus-area/action/${actionId}/acknowledge`
    )
}
